import React from 'react';
import './rcm.css';

// The three demo-console detours of the revenue-cycle tour, as captured
// figures. A signed-in viewer with a seat on demo-nventr is taken to the
// live screen (CONCEPT_TOURS step `path`); a visitor — the page is
// unlisted-public — is shown these instead (`visitorPath` → ?fig=demo-*).
// Re-capture at 1440×900 when the console's look changes (dark theme,
// demo-nventr): /orgs/demo-nventr/blueprint, the invoice-posting-gated
// pipeline (Fit View), /orgs/demo-nventr/human-review.
const SHOTS = {
  'demo-blueprint': {
    src: '/concepts/revenue-cycle-demo-blueprint.png',
    alt: 'Blueprint on the demo organization — the map on day one: systems, data, processes, people, initiatives, impact; "Map it with NoVA"',
    label: 'Blueprint · the demo organization, day one',
    note: 'Blueprint on the demo organization: the map before anything is mapped — systems, data, processes, people, then initiatives and impact. NoVA interviews the people who do the work and fills it in.',
  },
  'demo-pipeline': {
    src: '/concepts/revenue-cycle-demo-pipeline.png',
    alt: 'An nQube workflow on the demo organization — invoice posting, gated over $10k: read, extract, branch, a person approves, post',
    label: 'nQube · invoice posting, gated over $10k',
    note: 'A live nQube workflow on the demo organization: five blocks — read the invoices, extract fields, branch on the amount, a person approves, post to the ERP. The gate is a block, not a prompt.',
  },
  'demo-review': {
    src: '/concepts/revenue-cycle-demo-review.png',
    alt: 'Human Review on the demo organization — the gate where a person approves or rejects what an agent proposes, with the evidence and the record of who decided',
    label: 'Human Review · the gate',
    note: 'Human Review on the demo organization: what the agent wants to do, the evidence, approve or reject, and who decided — the ledger a compliance team audits.',
  },
};

function shot(id) {
  const s = SHOTS[id];
  return function DemoShot() {
    return (
      <div className="as-screen rcm-shot" data-nova-note={s.note}>
        <img src={s.src} alt={s.alt} loading="lazy" />
        <div className="as-foot">
          <span className="as-foot-chip">Captured · demo organization</span>
          <span>{s.label}. Signed-in viewers are taken to the live screen; this is the same view.</span>
        </div>
      </div>
    );
  };
}

export const DEMO_SHOTS = Object.fromEntries(Object.keys(SHOTS).map((id) => [id, shot(id)]));
